'use es6';

import I18n from 'I18n';
import { List } from 'immutable';
import { createSelector } from 'reselect';
import { getBookInfo, getMeetingLength, getUserTimezone, getEvent } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getIsFetchingPublicAvailability, availabilityFetchFailed as getAvailabilityFetchFailed } from 'MeetingsLib/selectors/RequestStatusSelectors';
export var getLinkAvailabilityByDuration = createSelector([getIsFetchingPublicAvailability, getAvailabilityFetchFailed, getBookInfo], function (isFetchingPublicAvailability, availabilityFetchFailed, bookInfo) {
  var availabilityByDuration = bookInfo.getIn(['linkAvailability', 'linkAvailabilityByDuration']);

  if (isFetchingPublicAvailability || availabilityFetchFailed || !availabilityByDuration) {
    return List();
  }

  return availabilityByDuration;
});
export var getAvailabilityForSelectedDuration = createSelector([getIsFetchingPublicAvailability, getAvailabilityFetchFailed, getLinkAvailabilityByDuration, getMeetingLength], function (isFetchingPublicAvailability, availabilityFetchFailed, linkAvailabilityByDuration, duration) {
  if (isFetchingPublicAvailability || availabilityFetchFailed || !linkAvailabilityByDuration.size) {
    return List();
  }

  return linkAvailabilityByDuration.find(function (availabilityByDuration) {
    return availabilityByDuration.get('meetingDurationMillis') === duration;
  }).get('availabilities');
});
export var getAvailableStartTimes = createSelector([getAvailabilityForSelectedDuration], function (availabilities) {
  return availabilities.map(function (availability) {
    return availability.get('startMillisUtc');
  });
});
export var getGroupedAvailableTimes = createSelector([getAvailableStartTimes, getUserTimezone], function (startTimes, userTimezone) {
  return startTimes.groupBy(function (startMillisUtc) {
    return I18n.moment(startMillisUtc).tz(userTimezone).format('YYYY-MM-DD');
  });
});
export var getAvailableDates = createSelector([getGroupedAvailableTimes], function (groupedAvailableTimes) {
  return groupedAvailableTimes.keySeq();
});
export var isSelectedDateAvailable = createSelector([getAvailableDates, getEvent], function (availableDates, event) {
  return availableDates.includes(event.dateString);
});
export var getAvailableStartTimesForSelectedDate = createSelector([getGroupedAvailableTimes, getEvent], function (groupedAvailableTimes, event) {
  return groupedAvailableTimes.get(event.dateString) || List();
});